import { createSelector } from 'reselect';
import { List as iList } from 'immutable';

const impersonates = (state) => state.get('impersonates', iList());

export const impersonatesSelector = createSelector([impersonates], (impersonates) => impersonates);
